import debounce from "../helpers/debounce";

class Header {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.setHeightProperty();

        const scrollDebounce = debounce(function () {
            if(window.scrollY > 0) {
                self.elem.classList.add('is-shrunk');
            } else {
                self.elem.classList.remove('is-shrunk');
            }
        });

        window.addEventListener('scroll', function () {
            scrollDebounce();
        }, false);
    }

    setHeightProperty() {
        let self = this;

        self.headerHeight = self.elem.offsetHeight;

        document.documentElement.style.setProperty("--header-height", self.headerHeight + 'px');
    }
}

export default Header;
